module.exports = require("postcss-safe-parser");